<template>
  <div class="text-primary l-h-22 grey">
    <p>
      STATECS has experience in a wide range of therapeutic areas. Check them out below:
    </p>
    <h5>Oncology</h5>
    <p>
      Medical data is a serious thing to handle regardless of the therapeutic area you are in as
      in every case human lives are at stake. This is why, in order to carry out your oncology
      trials, you should choose an organization that has experience in that area and offers more
      than the traditional full-service data collection and management services.
    </p>
    <p>
      At STATECS, we have deep insights into oncology trials as we have worked with many
      oncology-centered drug development companies in the past. Our expertise in this field
      allows us to proudly state that we can considerably improve your trial process making
      it error-free and statistically sound.
    </p>
    <p>
      Here is what we offer:
    </p>
    <ul class="ml-4">
      <li>
        <b>Highly Complex Datasets:</b> Production of complex datasets that contain data from
        numerous sources in large volumes and standardization of this data for successful
        clinical trial reporting.
      </li>
      <li>
        <b>Collaboration with Third-Party Vendors:</b> Assistance in the management of your
        third-party vendors: providers of tumor markers, biomarkers, safety laboratory data,
        etc. Ensuring all the required data for your oncology trials are gathered in a single
        place for faster access and analysis.
      </li>
      <li>
        <b>Data Standardization:</b> Let us help you comply with CDISC standards and produce a
        consolidated database in the common standardized formats (SDTMs & ADaMs). Being well
        aware of the recent CDISC guidelines and regulatory requirements as well as having deep
        knowledge of the latest medical dictionaries, you can rest assured that our experts will
        highly ease your clinical trial process by providing you with data consistency and
        standardization.
      </li>
      <li>
        <b>Dealing with Large Volumes of Data:</b> Our clinical data management team will handle
        your increased volume of data with the help of the latest data collection methods.
        Additionally, our experienced statisticians will capture all the relevant data from
        any mobile device or eSource technology according to your trial design. We will make
        your clinical trial reporting compatible with big theories and with the latest statistical
        programming methodologies that can handle large volumes of data.
      </li>
      <li>
        <b>Real-World Data Analysis:</b> We come with experience in supporting regulatory approval
        processes for studies that have had real-world data as the basis of their trials.
      </li>
      <li>
        <b>Regulatory Submission Timelines:</b> STATECS can help you manage the tight regulatory
        submission deadlines without affecting the quality of your work.
      </li>
      <li>
        <b>Choosing the Right Oncology Study Designs:</b> Our simulation-based methods will help
        you choose the right oncology study design and sample size for Phase 1 dose determining
        processes.
      </li>
      <li>
        <b>Additional Reporting:</b> We will cover all your reporting needs for data and
        safety monitoring committees.
      </li>
      <li>
        <b>Efficacy Endpoints:</b> Our personalized trials will help you measure your goal
        endpoints and understand the efficiency of your treatment.
      </li>
      <li>
        <b>Real-Time Oncology Review:</b> Get your treatments approved faster.
      </li>
    </ul>
    <p>
      We will walk you all the way through the oncology development stages: from study onset
      and conduct to data analysis, regulatory submissions, post submission and approval processes.
    </p>
    <h5>Cardiovascular & Metabolic</h5>
    <p>
      Stroke, coronary heart disease, acute coronary syndromes, heart failure: STATECS has worked
      with therapeutic organizations studying the above-listed cardiovascular and metabolic
      diseases.
    </p>
    <h5>Respiratory & Immuno-Inflammatory</h5>
    <p>
      STATECS has in-depth expertise in working on respiratory and immuno-inflammatory cases which
      include various studies on rhinitis, asthma, psoriasis, renal and liver transplantation, etc.
    </p>
    <h5>Dermatology</h5>
    <p>
      STATECS has experience in handling data from clinical trials on acne, dermatitis, a topic
      eczema, psoriasis lesions, etc.
    </p>
    <h5>Ophthalmology</h5>
    <p>
      Yet another area where we managed to have our fair share of knowledge and skill investment.
      We worked on clinical trials that focused on age-related macular degeneration, contact
      lenses and interocular lenses applications, and diabetic macular edema.
    </p>
    <h5>Hematology</h5>
    <p>
      STATECS has worked on multiple clinical trials dealing with hematology at different
      trial phases.
    </p>
    <div class="card-ctx">
      <h5>Vaccine & Virology</h5>
      <p>
        Our team has helped conduct various studies on vaccines aiming to find out antibody response
        and clinical signs. Considering the current pandemic, we see this area as one of the most
        important in clinical research and strive to provide high-quality data management services
        to companies focusing on the development and trial of vaccines.
      </p>
      <h5>Nephrology, Renal, and Urology</h5>
      <p>
        Chronic Kidney disease, Anaemia, and Benign Prostatic Hyperplasia have been under
        investigation by the companies we collaborated with to help in the success of their
        clinical trials.
      </p>
    </div>
    <b-card-title
      class="title text-primary font-weight-bold f-s-22 l-s-0"
      style="left: 46%"
    >
      {{ modalItem.title }}
    </b-card-title>
  </div>
</template>

<script>
export default {
  name: 'TherapeuticExperience',
  props: {
    modalItem: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
